import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'
import en from 'dayjs/locale/en'

dayjs.extend(utc)
dayjs.extend(timezone)

/**
 *
 * @param {object} pointWxData
 * @param {number} now
 */
export const formatPointWeather = (pointWxData, now) => {
  const timezone = pointWxData.timezone
  const nowInTz = dayjs.unix(now).tz(timezone)

  const hourList = pointWxData.srf
    .map((item) => {
      const tm = dayjs.unix(item.utm).tz(timezone)
      const isHourlyTz = tm.minute() === 0
      const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
      const isPast = modifiedTm.startOf('hour').unix() < nowInTz.startOf('hour').unix()
      return {
        ...item,
        past: isPast,
        time: modifiedTm.format('H'),
        date: modifiedTm.locale(ja).format('D日(ddd)')
      }
    })
    .filter((item) => !item.past)

  // chunk by day
  const hourly = hourList.reduce((acc, item, currentIndex) => {
    // 23時始まりのときは、'日'をカット
    if (acc.length === 0 && item.time === '23') {
      acc.push({ date: item.date.replace('日', ''), hourList: [item] })
      return acc
    }

    if (acc.length === 0) {
      acc.push({ date: item.date, hourList: [item] })
      return acc
    }
    const last = acc[acc.length - 1]
    const isNewDay = last && last.date !== item.date
    if (isNewDay) {
      // ラストのコマに1時間分しか存在しない場合は、'日'をカット
      const date_ = hourList.length === currentIndex + 1 ? item.date.replace('日', '') : item.date
      acc.push({ date: date_, hourList: [item] })
      return acc
    }
    last.hourList.push(item)
    return acc
  }, [])

  const mrf = calcClothTemp(pointWxData.srf, pointWxData.mrf, timezone)

  const todayTomorrow = mrf
    .map((item) => {
      const tm = dayjs.unix(item.utm).tz(timezone)
      const isHourlyTz = tm.minute() === 0
      const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
      const isPast = modifiedTm.startOf('day').unix() < nowInTz.startOf('day').unix()
      const isToday = modifiedTm.startOf('day').unix() === dayjs.unix(now).tz(timezone).startOf('day').unix()
      return {
        ...item,
        past: isPast,
        label: isToday ? '今日' : '明日',
        date: tm.locale(ja).format('M月D日(ddd)'),
        dowEn: tm.locale(en).format('ddd').toLowerCase()
      }
    })
    .filter((item) => {
      if (item.past) return false
      if (item.utm <= now + 86400) return true
    })

  const week = pointWxData.mrf
    .map((item) => {
      const tm = dayjs.unix(item.utm).tz(timezone)
      const isHourlyTz = tm.minute() === 0
      const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
      const isPast = modifiedTm.startOf('day').unix() < nowInTz.startOf('day').unix()
      return {
        ...item,
        past: isPast,
        date: tm.format('D'),
        dowEn: tm.locale(en).format('ddd').toLowerCase(),
        dowJa: tm.locale(ja).format('ddd')
      }
    })
    .filter((item) => {
      if (item.past) return false
      if (item.utm <= now + 86400 * 14) return true
    })

  return {
    hourly,
    todayTomorrow,
    week,
    timezone
  }
}
